// src/services/FetchEmployees.js

import { baseUrl_SPB } from "../BaseUrl";

const FetchEmployeesService = async (token, selectedLocation) => {
  try {
    if (!selectedLocation?.id || !selectedLocation?.companyId) {
      throw new Error('Invalid location data');
    }

    const response = await fetch(
      `${baseUrl_SPB}/api/v1/user/getemployees?locationId=${selectedLocation.id}&companyId=${selectedLocation.companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch employees');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching employees:', error);
    return null;
  }
};

export default FetchEmployeesService;
